<template>
  <div class="container is-size-7">
    <div class="field is-horizontal">
      <div class="field-body">
        <div class="field is-narrow">
          <div class="control">
            <div class="select is-fullwidth">
              <select v-model="cmbPerfil">
                <option value="0" disabled>Selecione um perfil</option>
                <option v-for="up in usuariosPerfil" :key="up.perfil.id" :value="up.perfil.id">
                  {{ up.perfil.descricao }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="field">
          <button type="submit" class="button is-primary" @click.stop.prevent="filterRecords">Notas Explicativas</button>
        </div>
        <div class="field">
          <button class="button is-primary is-pulled-right" @click="add()">
            <span class="icon">
              <i class="fas fa-plus"></i>
            </span>
            <span>Cadastrar</span>
          </button>
        </div>
      </div>
    </div>
    <hr>

    <div class="modal" :class="{ 'is-active': isShowModal }">
      <div class="modal-background" v-on:click="isShowModal = false"></div>
      <div class="modal-card">
        <header class="modal-card-head has-background-primary">
          <p class="modal-card-title has-text-white">Cadastrar</p>
          <button class="delete" aria-label="close" v-on:click="isShowModal = false"></button>
        </header>
        <section class="modal-card-body">
          <form v-if="!mostraNotaExplicativaNotas">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                  <label class="label">Descrição</label>
              </div>
              <div class="field-body">
                <div class="field">
                    <input
                    class="input"
                    type="text"
                    placeholder="Informe a descrição da nota explicativa"
                    v-model="notaExplicativaPeriodo.descricao">
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Sequencial</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <p class="control">
                    <input class="input" type="text" v-model="notaExplicativaPeriodo.sequencial">
                  </p>
                </div>
              </div>
            </div>
            
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Vigência Inicial</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <input class="input" type="date" placeholder="Informe a vigência inicial" v-model="notaExplicativaPeriodo.vigencia_inicial">
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Vigência Final</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <input class="input" type="date" placeholder="Informe a vigência final" v-model="notaExplicativaPeriodo.vigencia_final">
                </div>
              </div>
            </div>
          </form>

          <form v-if="mostraNotaExplicativaNotas">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                  <label class="label">Texto</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <textarea class="textarea" placeholder="Informe o texto da nota explicativa" v-model="notaExplicativaNota.texto"></textarea>
                </div>
              </div>
            </div>
            
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Vigência Inicial</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <input class="input" type="date" placeholder="Informe a vigência inicial" v-model="notaExplicativaNota.vigencia_inicial">
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Vigência Final</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <input class="input" type="date" placeholder="Informe a vigência final" v-model="notaExplicativaNota.vigencia_final">
                </div>
              </div>
            </div>
          </form>
        </section>

        <footer class="modal-card-foot">
          <button class="button is-success" @click="save">Salvar</button>
          <button class="button" v-on:click="isShowModal = false">Cancelar</button>
        </footer>
      </div>
    </div>

    <div class="columns" v-show="showInfo">
      <div class="column is-two-fifths">
        <div class="card">
          <header class="card-header has-background-primary">
            <p class="card-header-title has-text-white">Notas Explicativas</p>
          </header>
          <div class="card-content">
            <div class="table-container">
              <table class="table is-fullwidth is-striped is-hoverable">
                <thead>
                  <tr>
                    <th>Seq.</th>
                    <th>Descrição</th>
                    <th colspan="3" class="has-text-centered">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(nep, index ) in notasExplicativasPeriodo" :key="nep.id">
                    <td>{{ nep.sequencial }}</td>
                    <td>{{ nep.descricao }}</td>
                    <td class="has-text-centered">
                      <div class="buttons is-centered">
                        <button class="button is-small is-info is-outlined" @click="edit(index)" title="Editar perfil" :disabled="mostraNotaExplicativaNotas">
                          <span class="icon is-small">
                            <i class="fas fa-edit"></i>
                          </span>
                        </button>
                        <button class="button is-small is-danger is-outlined" @click="erase(index)" title="Excluir perfil" :disabled="mostraNotaExplicativaNotas">
                          <span class="icon is-small">
                            <i class="fas fa-trash-alt"></i>
                          </span>
                        </button>
                        <button class="button is-small is-success is-outlined" @click="callNotas(nep)" title="Lançar notas" :disabled="mostraNotaExplicativaNotas">
                          <span class="icon is-small">
                            <i class="fas fa-th-list"></i>
                          </span>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="column" v-show="mostraNotaExplicativaNotas">
        <div class="card">
          <header class="card-header has-background-grey">
            <p class="card-header-title has-text-white">{{ notaExplicativaSelecionada.descricao }}</p>
            <a class="card-header-icon" @click="mostraNotaExplicativaNotas = false">
              <span class="icon">
                <i class="fas fa-times"></i>
              </span>
            </a>
          </header>
          <div class="card-content">
            <div class="table-container">
              <table class="table is-fullwidth is-striped is-hoverable">
                <thead>
                  <tr>
                    <th>Nota</th>
                    <th class="has-text-centered">Ação</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(nen, index) in notasExplicativasNotas" :key="nen.id">
                    <td>{{ nen.texto }}</td>
                    <td class="has-text-centered">
                      <div class="buttons is-centered">
                        <button class="button is-small is-info is-outlined" @click="edit(index)" title="Editar">
                          <span class="icon is-small">
                            <i class="fas fa-edit"></i>
                          </span>
                        </button>
                        
                        <button class="button is-small is-danger is-outlined" @click="erase(index)" title="Excluir">
                          <span class="icon is-small">
                            <i class="fas fa-trash-alt"></i>
                          </span>
                        </button>

                        <button class="button is-small is-warning is-outlined" @click="abrirNotasBP(nen)" title="Associar ao Balanço">BP
                        </button>

                        <button class="button is-small is-warning is-outlined" @click="abrirNotasDR(nen)" title="Associar ao DRE">DR
                        </button>
                        
                        <!-- <button class="button is-small is-warning is-outlined" @click="abrirNotasPC(nen)" title="Associar ao Plano de Contas">PC
                        </button> -->

                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <footer class="card-footer">
            <a @click="mostraNotaExplicativaNotas = false" class="card-footer-item">Fechar</a>
          </footer>
        </div>
      </div>
    </div>

    <nota-explicativa-bp v-if="linhaSelecionada && mostrarNotasBP" :key="'bp-'+linhaSelecionada.id" :visivel="mostrarNotasBP" :linha="linhaSelecionada" @fechar="fecharNotasBP"/>
    <nota-explicativa-dr v-else-if="linhaSelecionada && mostrarNotasDR" :key="'dr-'+linhaSelecionada.id" :visivel="mostrarNotasDR" :linha="linhaSelecionada" @fechar="fecharNotasDR"/>
    <nota-explicativa-pc v-else-if="linhaSelecionada && mostrarNotasPC" :key="'pc-'+linhaSelecionada.id" :visivel="mostrarNotasPC" :linha="linhaSelecionada" @fechar="fecharNotasPC"/>

  </div>
</template>

<script>
    import {http} from '../../services/config'
    import moment from 'moment'
    import NotaExplicativaBp from './NotaExplicativaBP.vue'
    import NotaExplicativaDr from './NotaExplicativaDR.vue'
    import NotaExplicativaPc from './NotaExplicativaPC.vue'

    export default {
        name: "NotaExplicativa",

        components: { NotaExplicativaBp, NotaExplicativaDr, NotaExplicativaPc },

        data(){
            return{
                notaExplicativaPeriodo: {
                  id: null,
                  perfil: null,
                  descricao: null,
                  sequencial: null,
                  vigencia_inicial: null,
                  vigencia_final: null,
                  index: null
                },
                notaExplicativaNota: {
                  if: null,
                  nota_explicativa_periodo: null,
                  texto: null,
                  vigencia_inicial: null,
                  vigencia_final: null,
                  index: null
                },
                usuariosPerfil: [],
                notasExplicativasPeriodo: [],
                notasExplicativasNotas: [],
                notaExplicativaSelecionada: {
                    id: null,
                    perfil: null,
                    descricao: null,
                    sequencial: null,
                    vigencia_inicial: null,
                    vigencia_final: null,
                    index: null
                },
                cmbPerfil: 0,
                showInfo: false,
                mostraNotaExplicativaNotas: false,
                isShowModal: false,
                mostrarNotasBP: false,
                mostrarNotasDR: false,
                mostrarNotasPC: false,
                linhaSelecionada: null,
            }
        },

        methods: {
            abrirNotasBP(linha) {
              this.linhaSelecionada = linha;
              this.mostrarNotasBP = true;
            },       

            abrirNotasDR(linha) {
              this.linhaSelecionada = linha;
              this.mostrarNotasDR = true;
            },       

            abrirNotasPC(linha) {
              this.linhaSelecionada = linha;
              this.mostrarNotasPC = true;
            },       
            
            fecharNotasBP() {
              this.mostrarNotasBP = false;
              this.linhaSelecionada = null;
            },            

            fecharNotasDR() {
              this.mostrarNotasDR = false;
              this.linhaSelecionada = null;
            },            

            fecharNotasPC() {
              this.mostrarNotasPC = false;
              this.linhaSelecionada = null;
            },            

            add: function() {
                if (this.cmbPerfil == '0') {
                    alert('Perfil não selecionado!')
                    return;
                }
                this.clearFields()
                this.isShowModal = true
            },

            edit: function(index){
              if (!this.mostraNotaExplicativaNotas) {
                this.notaExplicativaPeriodo.id = this.notasExplicativasPeriodo[index].id
                this.notaExplicativaPeriodo.perfil = this.notasExplicativasPeriodo[index].perfil
                this.notaExplicativaPeriodo.descricao = this.notasExplicativasPeriodo[index].descricao
                this.notaExplicativaPeriodo.sequencial = this.notasExplicativasPeriodo[index].sequencial
                this.notaExplicativaPeriodo.vigencia_inicial = this.notasExplicativasPeriodo[index].vigencia_inicial
                this.notaExplicativaPeriodo.vigencia_final = this.notasExplicativasPeriodo[index].vigencia_final
                this.notaExplicativaPeriodo.index = index
              } else {
                  this.notaExplicativaNota.id = this.notasExplicativasNotas[index].id
                  this.notaExplicativaNota.nota_explicativa_periodo = this.notasExplicativasNotas[index].nota_explicativa_periodo
                  this.notaExplicativaNota.texto = this.notasExplicativasNotas[index].texto
                  this.notaExplicativaNota.vigencia_inicial = this.notasExplicativasNotas[index].vigencia_inicial
                  this.notaExplicativaNota.vigencia_final = this.notasExplicativasNotas[index].vigencia_final
                  this.notaExplicativaNota.index = index
              }
              this.isShowModal = true              
            },

            erase: function(index){
                if (window.confirm('Confirma exclusão?')) {
                    http.delete('/notaExplicativa/excluir/'+this.notasExplicativasPeriodo[index].id).then(response =>{
                        this.notasExplicativasPeriodo.splice(index, 1)
                        if (response.status == 204) {
                            alert('Registro excluído!')
                        }
                    }).catch(e => {
                        console.log(e);
                    })
                }
            },

            save: function(){
                var data

                if (!this.mostraNotaExplicativaNotas) {
                  if (this.notaExplicativaPeriodo.descricao == null || this.notaExplicativaPeriodo.descricao == '') {
                      alert('Descrição não informada!')
                      return
                  }

                  if (this.notaExplicativaPeriodo.sequencial == null ) {
                      alert('Sequencial não informado!')
                      return
                  }

                  if (this.notaExplicativaPeriodo.vigencia_inicial == null ) {
                      alert('Vigência inicial não informada!')
                      return
                  }

                  if (this.notaExplicativaPeriodo.vigencia_final) {
                    if (this.notaExplicativaPeriodo.vigencia_final < this.notaExplicativaPeriodo.vigencia_inicial ) {
                      alert('Vigência final não pode ser inferior a vigência inicial!')
                      return
                    }
                  } 

                  data = {id: this.notaExplicativaPeriodo.id,
                      descricao: this.notaExplicativaPeriodo.descricao,
                      sequencial: this.notaExplicativaPeriodo.sequencial,
                      perfil: this.cmbPerfil,
                      vigencia_inicial: moment(this.notaExplicativaPeriodo.vigencia_inicial).format('DD/MM/YYYY'),
                      vigencia_final: null
                  }

                  if (this.notaExplicativaPeriodo.vigencia_final) {
                    data.vigencia_final = moment(this.notaExplicativaPeriodo.vigencia_final).format('DD/MM/YYYY')
                  }

                  if (this.notaExplicativaPeriodo.id == null) {
                      http.post('/notaExplicativa/adicionar', data).then(response =>{
                          if (response.data.id != undefined && response.data.id != '') {
                              this.notaExplicativaPeriodo.id = response.data.id
                              this.notasExplicativasPeriodo.push(this.notaExplicativaPeriodo)
                              this.clearFields()
                          } else {
                              alert(response.request.responseText)
                          }
                      }).catch(e => {
                          alert(e.response.data);
                          return
                      })
                  } 
                  else {
                      http.put('/notaExplicativa/editar/'+this.notaExplicativaPeriodo.id, data).then(response =>{
                          this.notasExplicativasPeriodo[this.notaExplicativaPeriodo.index].descricao = response.data.descricao
                          this.notasExplicativasPeriodo[this.notaExplicativaPeriodo.index].sequencial = response.data.sequencial
                          this.notasExplicativasPeriodo[this.notaExplicativaPeriodo.index].vigencia_inicial = response.data.vigencia_inicial
                          this.notasExplicativasPeriodo[this.notaExplicativaPeriodo.index].vigencia_final = response.data.vigencia_final
                      }).catch(e => {
                          alert(e.response.data);
                          return
                      })
                  }                    

                } else {
                  if (this.notaExplicativaNota.texto == null || this.notaExplicativaNota.texto == '') {
                    alert("Texto da nota explicativa não informado!")
                  }

                  if (!this.notaExplicativaNota.vigencia_inicial) {
                      alert('Vigência inicial não informada!')
                      return
                  } else {
                    if (this.notaExplicativaNota.vigencia_inicial < this.notaExplicativaSelecionada.vigencia_inicial) {
                      alert('Vigência inicial informada não pode ser inferior a vigência inicial indicada na nota explicativa!')
                      return
                    }
                  }

                  if (this.notaExplicativaNota.vigencia_final) {
                    if (this.notaExplicativaNota.vigencia_final < this.notaExplicativaNota.vigencia_inicial ) {
                      alert('Vigência final não pode ser inferior a vigência inicial!')
                      return
                    }
                    if (this.notaExplicativaNota.vigencia_final > this.notaExplicativaSelecionada.vigencia_final) {
                      alert('Vigência final informada não pode ser superior a vigência final indicada na nota explicativa!')
                      return
                    }

                  } else {
                    if (this.notaExplicativaSelecionada.vigencia_final) {
                      this.notaExplicativaNota.vigencia_final = this.notaExplicativaSelecionada.vigencia_final
                    }
                  }

                  data = {id: this.notaExplicativaNota.id,
                      nota_explicativa_periodo: this.notaExplicativaSelecionada.id,
                      texto: this.notaExplicativaNota.texto,
                      vigencia_inicial: moment(this.notaExplicativaNota.vigencia_inicial).format('DD/MM/YYYY'),
                      vigencia_final: null
                  }

                  if (this.notaExplicativaNota.vigencia_final) {
                    data.vigencia_final = moment(this.notaExplicativaNota.vigencia_final).format('DD/MM/YYYY')
                  }

                  if (this.notaExplicativaNota.id == null) {
                      http.post('/notaExplicativa/adicionarNotas', data).then(response =>{
                          if (response.data.id != undefined && response.data.id != '') {
                              this.notaExplicativaNota.id = response.data.id
                              this.notasExplicativasNotas.push(this.notaExplicativaNota)
                              this.clearFields()
                          } else {
                              alert(response.request.responseText)
                          }
                      }).catch(e => {
                          alert(e.response.data);
                          return
                      })
                  } 
                  else {
                      http.put('/notaExplicativa/editarNotas/'+this.notaExplicativaNota.id, data).then(response =>{
                          this.notasExplicativasNotas[this.notaExplicativaNota.index].texto = response.data.texto
                          this.notasExplicativasNotas[this.notaExplicativaNota.index].vigencia_inicial = response.data.vigencia_inicial
                          this.notasExplicativasNotas[this.notaExplicativaNota.index].vigencia_final = response.data.vigencia_final
                      }).catch(e => {
                          alert(e.response.data);
                          return
                      })
                  }                    

                }
            },

            clearFields: function() {
              if (!this.mostraNotaExplicativaNotas) {
                this.notaExplicativaPeriodo = {
                    id: null,
                    perfil: null,
                    descricao: null,
                    sequencial: null,
                    vigencia_inicial: null,
                    vigencia_final: null,
                    index: null
                }
              } else {
                this.notaExplicativaNota = {
                    id: null,
                    nota_explicativa_periodo: null,
                    texto: null,
                    vigencia_inicial: this.notaExplicativaSelecionada.vigencia_inicial,
                    vigencia_final: this.notaExplicativaSelecionada.vigencia_final,
                    index: null
                }
              }

            },

            filterRecords: function(){
                http.get('notaExplicativa/listar/', {params: {
                    idPerfil: this.cmbPerfil
                }}).then(response => {
                    this.notasExplicativasPeriodo = response.data.results
                    if (this.notasExplicativasPeriodo.length == 0) {
                        this.showInfo = false
                        alert('Não há notas explicativas associadas aos parâmetros selecionados!')
                    } else {
                        this.showInfo = true
                    }
                })
            },

            callNotas: function(ne) {
                this.mostraNotaExplicativaNotas = true
                this.notaExplicativaSelecionada = ne
                http.get('notaExplicativa/listarNotas/', {params: {
                    idNotaExplicativa: this.notaExplicativaSelecionada.id,
                }}).then(response => {
                    this.notasExplicativasNotas = response.data.results
                })
            }

        },

        mounted: function() {
        },
        
        created: function() {
            http.get('compartilharPerfis/listarPerfis').then(response => {
                    this.usuariosPerfil = response.data.results
            })

        }

    }
</script>

<style scoped>
</style>